export default __webpack_public_path__ + "static/media/03.bc031988.jpg";